"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTotalAmountFromDrawRounded = exports.getDrawAmountFromTotalFloor = exports.getTotalAmountFromDraw = exports.getDrawAmountFromTotal = exports.amortizingLoanPayment = void 0;

// https://www.thebalance.com/loan-payment-calculations-315564
var amortizingLoanPayment = function amortizingLoanPayment(term, decimalRate, amount) {
  if (typeof term !== 'number' || typeof decimalRate !== 'number' || typeof amount !== 'number') return null;
  if (term < 0 || decimalRate < 0 || amount < 0) return NaN;
  var numberOfPayments = term * 12;
  var periodicInterestRate = decimalRate / 12;
  var discountFactor = (Math.pow(1 + periodicInterestRate, numberOfPayments) - 1) / (periodicInterestRate * Math.pow(1 + periodicInterestRate, numberOfPayments));
  return amount / discountFactor;
};

exports.amortizingLoanPayment = amortizingLoanPayment;

var getDrawAmountFromTotal = function getDrawAmountFromTotal(amount, fee) {
  return amount / (1.0 + fee);
};

exports.getDrawAmountFromTotal = getDrawAmountFromTotal;

var getTotalAmountFromDraw = function getTotalAmountFromDraw(amount, originationFee) {
  return amount * (1 + originationFee);
}; // by default in UI, we show end user these values in whole numbers and reverse compute as necessary


exports.getTotalAmountFromDraw = getTotalAmountFromDraw;

var getDrawAmountFromTotalFloor = function getDrawAmountFromTotalFloor(amount, fee) {
  return Math.floor(getDrawAmountFromTotal(amount, fee));
};

exports.getDrawAmountFromTotalFloor = getDrawAmountFromTotalFloor;

var getTotalAmountFromDrawRounded = function getTotalAmountFromDrawRounded(amount, originationFee) {
  return Math.round(getTotalAmountFromDraw(amount, originationFee));
};

exports.getTotalAmountFromDrawRounded = getTotalAmountFromDrawRounded;